import { Theme } from "./../styles";
import { TextAndBoxStyleConfig } from "./../types/global";

export const getBoxFillStyle = (config: TextAndBoxStyleConfig, theme: Theme) => {
  const { isCurrent, isBusinessDay, isHoliday, variant } = config;

  if (variant === "yearView")
    return isCurrent ? theme.colors.tertiary : theme.colors.gridBackground;
  if(isHoliday) return '#ffe0e0';
  if (isCurrent) return theme.colors.secondary;
  if (!isBusinessDay) return theme.colors.primary;

  return '#ffffff';
};
